import React from 'react'
import AllOrdersList from "../mini/AllOrdersList"
import { useEffect } from 'react'
import ClipLoader from "react-spinners/ClipLoader";
import DashHeader from '../mini/DashHeader';
import { toast } from 'react-toastify';
import { useAllOrdersQuery } from '../../redux/services/ordersApi';

const AllOrders = () => {
    
    const { data, error, isLoading, isSuccess } = useAllOrdersQuery()

    useEffect(() => {
        if (!isLoading) {
            if (!isSuccess) {
                console.log(error)
                toast.error(error?.data?.message || error?.message, {
                    position: toast.POSITION.TOP_RIGHT
                })
            }
        }
      
    }, [isLoading, isSuccess, error, data])
    

    return (
        <>
            {
                isLoading ?
                <div className="loader">
                    <ClipLoader color="#fdc51c" loading={isLoading} size={80} /> 
                </div> :
                <div className='pull-up'>
                    <DashHeader title="All Orders" />
                    <AllOrdersList orders={data?.data} />
                </div>
            }
        </>
    )
}

export default AllOrders
